import {
  routes
} from "./chunk-7PKRU6HZ.js";

// src/project/form.tsx
import { useFormComponent, useMutation } from "@lb-lib/ui-data";
import { useBootWorkspace } from "@loopbound-ares/state";
import { useNavigate } from "react-router-dom";
var useCreateProjectForm = (opts) => {
  let navigate = useNavigate();
  return useFormComponent(() => ({
    initialData: {
      name: ""
    },
    fields: [{
      key: "name",
      kind: "text",
      type: "textfield",
      label: "Name",
      placeholder: "Choose a name for your project",
      validation: (yup) => yup.string().required("Project name is required")
    }],
    state: () => {
      let workspace = useBootWorkspace({
        workspaceId: opts.workspaceProduct.workspaceId,
        product: opts.workspaceProduct.product
      });
      let createProject = useMutation(workspace.mutators.createProject);
      return {
        isLoading: createProject.isLoading,
        isSuccess: createProject.isSuccess,
        initialData: {
          name: ""
        },
        mutate: async (data) => {
          let res = await createProject.mutate(data);
          if (res && opts.redirectOnCreate !== false) {
            let instance = res.instances[0];
            navigate(routes.instance_home({
              instanceSlug: instance.slug
            }));
          }
        }
      };
    },
    submitButton: {
      children: "Create Project"
    }
  }));
};
var useUpdateProjectForm = (opts) => {
  return useFormComponent(() => ({
    initialData: {
      name: "",
      slug: ""
    },
    fields: [{
      key: "name",
      kind: "text",
      type: "textfield",
      label: "Name",
      placeholder: "Name your project",
      validation: (yup) => yup.string().required("Project name is required")
    }, {
      key: "slug",
      kind: "text",
      type: "textfield",
      label: "Handle",
      placeholder: "Choose a handle for your project",
      validation: (yup) => yup.string().required("Project handle is required")
    }],
    state: () => {
      let workspace = useBootWorkspace(opts.project && opts.workspaceProduct ? {
        workspaceId: opts.project.workspaceId,
        product: opts.workspaceProduct.product
      } : null);
      let updateProject = useMutation(workspace.mutators.updateProject);
      let project = workspace.data?.projects.find((p) => p.id == opts.project.id);
      return {
        isLoading: updateProject.isLoading,
        isSuccess: updateProject.isSuccess,
        initialData: {
          name: project?.name ?? "",
          slug: project?.slug ?? ""
        },
        mutate: async (data) => {
          await updateProject.mutate({
            ...data,
            projectId: project?.id
          });
        }
      };
    },
    submitButton: {
      children: "Save"
    },
    updateInitialValues: true
  }));
};

export {
  useCreateProjectForm,
  useUpdateProjectForm
};
//# sourceMappingURL=chunk-PVCBGE2K.js.map